import { createGlobalStyle, css } from 'styled-components';

import { fromTabletBreakpoint } from '@/src/domains/shared/breakpoints';

// Custom fonts are loaded directly in _document.jsx
const GlobalStyle = createGlobalStyle`
  :root {
    --headerBrandHeight: 29px;
    --newBrandColor: #5700ff;
    --typography-fontBrand: 'Remote Sans', 'Inter', sans-serif;
    --typography-fontBossa: 'Bossa', 'Remote Sans', 'Inter', sans-serif;
  }

  button,
  a {
    cursor: pointer;
  }

  a {
    color: var(--colors-darkBlue);
    text-decoration: none;
  }

  :focus:not(:focus-visible) {
    outline: none;
  }

  html {
    scroll-padding-top: 76px;
    ${fromTabletBreakpoint(css`
      scroll-padding-top: 85px;
    `)}

    scroll-behavior: smooth;
    @media (prefers-reduced-motion) {
      scroll-behavior: auto;
    }
  }
`;

export default GlobalStyle;
